import { lazy } from 'react';
import { useModal } from 'src/components/modal';

const Component = lazy(() =>
  import('./DocImportDialog').then((module) => ({
    default: module.DocImportDialog,
  })),
);

export const useDocImportDialog = () => {
  const { hideModal, showModal } = useModal(Component, []);

  return {
    hideDocImport: hideModal,
    showDocImport: () => {
      // @ts-ignore
      if (typeof PDFJS === 'object') {
        showModal();
        return;
      }

      const scriptTag = document.createElement('script');
      // pdf-parse requires a old version of pdf.js
      scriptTag.src =
        'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/1.10.100/pdf.min.js';

      scriptTag.onload = () => {
        // @ts-ignore
        PDFJS.workerSrc =
          'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/1.10.100/pdf.worker.min.js';
        showModal();
      };
      document.head.appendChild(scriptTag);
    },
  };
};
